var map = {
	"./access_mode/controller.js": 15241,
	"./slug/controller.js": 89706,
	"src/decidim/admin/controllers/access_mode/controller.js": 15241,
	"src/decidim/admin/controllers/slug/controller.js": 89706
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98572;